import { useCallback, useReducer, useState } from "react";
import { reducer } from "../Reducers/reducer";
import { ApiConnector, setToken } from "common/ApiConnector";
import { sprintf } from "sprintf-js";
import { useTableBase } from "ComponentHooks/useTableBase";
import { App } from "antd";
import { useFormBase } from "ComponentHooks/useFormBase";
import { useModalBase } from "ComponentHooks/useModalBase";
import { FormComponent } from "../campaign_plans/FormComponent";
import dayjs from "dayjs";
import { HttpStatusCode } from "axios";
import { Tooltip } from "antd";

const url_endpoint = "api/v1/campaign-plans";

export const useCampaignsPlans = (cat_user_id) => {
    const { message } = App.useApp();
    const modalBase = useModalBase(<FormComponent />, "Formulario");
    const FormBase = useFormBase();
    const { modal, notification } = App.useApp();
    const tableBase = useTableBase();

    const [items, dispatch] = useReducer(reducer, []);
    const [campaigns, dispatchCampaigns] = useReducer(reducer, []);
    const [listContacts, dispatchListContacts] = useReducer(reducer, []);

    const [editID, setEditID] = useState(0);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 60,
            className: 'fw-bold',
            align: 'center',
            render: (value) => (<>{sprintf('%04d', value)}</>)
        },
        {
            title: 'Campaña',
            dataIndex: 'campaign',
            key: 'campaign',
            width: 200,
            // filterDropdown: tableBase.getColumnSearchProps('name').filterDropdown,
            // onFilterDropdownOpenChange: tableBase.getColumnSearchProps('name').onFilterDropdownOpenChange,
            render: (value) => (
                <>
                    { value.name }
                </>
            )
        },
        {
            title: 'Lista de Contactos',
            dataIndex: 'contact_list_item',
            key: 'contact_list_item',
            width: 200,
            render: (value) => (<>{value?.name}</>)
        },
        {
            title: 'Envío Programado',
            dataIndex: 'date_start',
            key: 'date_start',
            width: 120,
            align: 'center',
            render: (value) => value ? (<>{value}</>) : "Inmediato"
        },
        {
            title: 'Repetir envío cada semana',
            dataIndex: 'repeat_weekly',
            key: 'repeat_weekly',
            width: 120,
            align: 'center',
            sorter: true,
            render: (value) => value ? "Si" : "No"
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 150,
            align: 'center',
            render: (value) => {
                let status = (<>Desconocido</>);
                switch (value) {
                    case "IN_PROCESS":
                        status = (<span className="text-warning fw-bold">
                            <i className="fas fa-arrow-right me-2"></i>
                            EN PROCESO
                        </span>);
                        break;
                    case "FAILED":
                        status = (<span className="text-danger fw-bold">
                            <i className="fas fa-arrow-right me-2"></i>
                            FALLIDO
                        </span>);
                        break;
                    case "FINISHED":
                        status = (<span className="text-success fw-bold">
                            <i className="fas fa-arrow-right me-2"></i>
                            FINALIZADO
                        </span>);
                        break;
                    default: break;
                }
                return status;
            }
        },
        {
            title: 'Contactos enviados',
            dataIndex: 'index',
            key: 'index',
            width: 100,
            align: 'right',
            render: (value) => (<>{(value)}</>)
        },
        {
            title: 'Contactos restantes',
            dataIndex: 'contact_list',
            key: 'contact_list',
            width: 100,
            align: 'right',
            render: (value, item) => {
                if(!value) { return 0; }
                let count = value.length;
                let restante = count - item.index;
                return restante ?? 0;
            }
        },
        {
            title: 'Creado',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 100,
            align: 'center',
            render: (value) => {
                let c_at = dayjs(value);
                return (
                    <>{c_at.format('DD/MM/YYYY')} <br /> { c_at.format('hh:mm:ss') }</>
                );
            }
        },
        {
            title: '*',
            dataIndex: 'id',
            key: 'buttons',
            width: 50,
            className: 'text-center',
            render: (value, row) => (
                <Tooltip title="Eliminar">
                    <button className="btn btn-sm btn-danger py-0 px-2"
                        onClick={() => deleteItem(value)}
                    >
                        <i className="fas fa-trash"></i>
                    </button>
                </Tooltip>
            )
        },
    ];

    const updateToken = async () => {
        await setToken(atob(cat_user_id));
    }

    const handleTableChange = useCallback(
        (pagination, filters, sorter, extra) => { fillItems({ filters, sorter, pagination }) },
        []);

    const fillItems = useCallback(async (params = tableBase.tableParams) => {
        const { columnKey: column, order } = params.sorter;
        const { current: page, pageSize } = params.pagination;

        try {
            tableBase.loading();
            let { data } = await ApiConnector.get(`${url_endpoint}`, {
                params: {
                    filters: params.filters,
                    sorter: { column, order },
                    pagination: { pageSize, page },
                }
            });
            let { items, total } = data;

            dispatch({ type: "FILL", payload: items });

            tableBase.updateTableParams({
                ...params,
                pagination: { ...params.pagination, total: total }
            });
        } catch (error) { throw new Error(error); }
        finally { tableBase.loaded(); }
    }, [tableBase.tableParams])

    const fillCampaigns = useCallback(async () => {
        try {
            let res = await ApiConnector.get(`api/v1/campaigns`);
            dispatchCampaigns({ type: "FILL", payload: res.data.items });
        } catch (error) { console.log(error.message) }
    }, []);

    const fillListContacts = useCallback(async () => {
        try {
            let res = await ApiConnector.get(`api/v1/contact-list`);
            dispatchListContacts({ type: "FILL", payload: res.data.items });
        } catch (error) { console.log(error.message) }
    }, []);

    const getTableProps = () => tableBase.getTableProps(items, handleTableChange, columns);

    const getItemSelected = () => items.find(it => it.id === editID);

    const newItem = () => { setEditID(0); modalBase.open(); }

    const editItem = (item) => { setEditID(item.id); modalBase.open(); }

    const saveItem = async (item, formik) => {
        let res = (!item.id) ? await ApiConnector.post(`${url_endpoint}`, item) :
            await ApiConnector.put(`${url_endpoint}/${item.id}`, item);
        await fillItems();
        notification.success({
            description: "Item guardado correctamente."
        });
}

    const deleteItem = (id) => {
        modal.confirm({
            title: "Confirmación",
            content: "¿Eliminar item?",
            onOk: async () => {
                await ApiConnector.delete(`${url_endpoint}/${id}`);
                fillItems();
            }
        })
    }

    return {
        updateToken,
        getTableProps,
        FormBase,
        fillItems,
        getItemSelected,
        newItem,
        saveItem,
        editID,
        modalBase,
        campaigns: {
            fill: fillCampaigns,
            items: campaigns
        },
        listContacts: {
            fill: fillListContacts,
            items: listContacts
        }
    };
}
